module.exports = __webpack_public_path__ + "images/category_lp/common/man_30_7d8fd22142e6439028aaa7866582b72e.png";